var _effectorFileName = "/src/page-content/individual-lessons/components/help-achieve-goals/help-achieve-goals.tsx";
import { HELP_GOALS_INDIVIDUAL_LESSONS } from '@/widgets/layouts/main/constants/help-achieve-goals-lists';
import { Article } from '@/shared/components/article';
import { LineWithCircles } from '@/shared/components/line-with-circles';
export const HelpAchieveGoals = () => {
  return <Article>
      <h2 className="mb-4 header-h2 sm:mb-8">Как мы&nbsp;поможем вам достичь целей:</h2>

      <LineWithCircles>
        {HELP_GOALS_INDIVIDUAL_LESSONS.map((bulletPoint, index) => {
        return <div key={index}>
              <h3 className="mb-3 header-h3 sm:mb-5">{bulletPoint.title}</h3>

              <p className="text-sm text-muted-foreground" dangerouslySetInnerHTML={{
            __html: bulletPoint.description
          }} />

              {/* {bulletPoint.list?.points.length && (
                <div className="mt-3">
                  <h4 className="mb-3 text-base sm:text-[1.1rem]">{bulletPoint.list.title}</h4>
                   <ul className="mb-3 list-inside list-decimal space-y-1 text-sm sm:pl-4 sm:text-[0.95rem]">
                    {bulletPoint.list.points.map((point, index) => {
                      return <li key={index} dangerouslySetInnerHTML={{ __html: point }} />;
                    })}
                  </ul>
                </div>
               )} */}
            </div>;
      })}
      </LineWithCircles>
    </Article>;
};